import { render, staticRenderFns } from "./ApprovalDraft.vue?vue&type=template&id=27b7357b&scoped=true"
import script from "./ApprovalDraft.vue?vue&type=script&lang=js"
export * from "./ApprovalDraft.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDraft.vue?vue&type=style&index=0&id=27b7357b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b7357b",
  null
  
)

export default component.exports